<template>
    <div class="box-cont">
        <div class="card-box" v-for="(item, index) in itemSocial" :key="index">
            <img
                v-if="index === 0"
                src="/images/pose-3-min-bottom.png"
                class="scuirel-btm my-nuts bounce"
                alt="get in touch!"
            />
            <a :href="item.link" target="blank">
                <b-row no-gutters class="comp-box">
                    <b-col cols="12" class="text-center">
                        <img :src="item.icon" class="mob-img" alt="" />
                    </b-col>
                    <b-col cols="12">
                        <div class="text-title">
                            {{ item.title }}
                        </div>
                    </b-col>
                    <b-col cols="12" class="mob-text">
                        <div class="text-sub-title">
                            {{ item.subTitle }}
                        </div>
                    </b-col>
                </b-row>
            </a>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {};
    },
    props: {
        itemSocial: Array
    }
};
</script>
<style lang="scss">
@import "./resources/sass/_variables.scss";
.my-nuts {
    -webkit-animation-duration: 1s;
    animation-duration: 1s;
    // -webkit-animation-fill-mode: both;
    // animation-fill-mode: both;
}

@keyframes bounce {
    0%,
    20%,
    50%,
    80% {
        transform: translateY(10px);
    }
    40% {
        transform: translateY(0px);
    }
    60% {
        transform: translateY(5px);
    }
    100% {
        transform: translateY(0);
    }
}

.bounce {
    -webkit-animation-name: bounce;
    animation-name: bounce;
}

.box-cont {
    display: flex;
    justify-content: center;
    /* gap: 35px; */
    height: 100%;

    .scuirel-btm {
        position: absolute;
        width: 14.417vw; //9.5vw;
        height: 12.584vw;
        top: calc(-12vw / 1.35);
        //height: 9.584vw;
        //top: calc(-9.5vw / 1.35);
        left: calc(-9.5vw / 17);
        // width: 137.21px;
        // height: 144.29px;
        // left: 18%;
        // bottom: 77%;
        /* margin-left: -37vw;
        margin-top: calc( -9.5vw / 1.8 ); */
        // margin-top: -78px;
        z-index: 1;

        // @media only screen and (min-width: 1440px) {
        //     width: 161px;//193.2px
        //     height: 115px; //138px
        //     top: calc(-161px / 1.8);
        //     left: calc(-115px / 17);
        // }
    }
}
.card-box {
    position: relative;
    cursor: pointer;
    /* width: 16.8vw;
    height: calc(16.8vw / 1.35); */
    max-width: 105px;
    min-height: 58px;
    width: 100%;
    /* height: 100%; */
    padding: 36px;
    background: #1d1d1d;
    box-shadow: 0px 24px 62px 14px rgba(17, 17, 17, 0.32);
    border-radius: 20px;
    border: 0.3px solid rgba(39, 174, 96, 0.8);
        
    &:not(:first-child) {
        margin-left: 35px;
    }

    @media only screen and (min-width: 768px) {
        max-width: 243px;
        height: 180px;
        padding: 1.8055555555555556vw;
    }

    @media only screen and (min-width: 992px) {
        max-width: 16.875vw;
        min-height: 12.5vw;
        height: 100%;

        &:not(:first-child) {
            margin-left: 2.4305555555555554vw;
        }
    }

    a,
    a:hover {
        text-decoration: none !important;
    }
    .comp-box {
        margin: auto;
    }
    .text-title {
        font-family: Bungee;
        font-style: normal;
        font-weight: normal;
        // font-size: 14px;
        font-size: 1vmax;
        // line-height: 17px;
        line-height: calc(1vmax + 10px);
        text-align: center;
        letter-spacing: 0.04em;
        color: #27ae60;
        margin-top: 5px;

        @media screen and (min-width: 1440px) {
            font-size: 0.9722222222222222vw;
            line-height: 1.1076388888888888vw;
        }
    }
    .text-sub-title {
        font-family: Exo;
        font-style: normal;
        font-weight: 600;
        // font-size: 12px;
        font-size: calc(10px + 0.2vw);
        // line-height: 16px;
        text-align: center;
        text-transform: uppercase;
        color: $primary-4;
        margin-top: 2.0833333333333335vw;
        // margin-top: 30px;
        //padding: 0 5px;

        @media screen and (min-width: 1440px) {
            font-size: 0.8333333333333334vw;
            line-height: 1.1076388888888888vw;
        }
    }
    .mob-img {
        width: 32px;
        height: 32px;

        @media only screen and (min-width: 2500px) {
            width: calc(32px + 1.2vw);
            height: calc(32px + 1.2vw);
        }
    }
}
@media screen and (min-width: 0px) and (max-width: 768px) {
    .box-cont {
        /* gap: 10px !important; */
    }
    .card-box {
        width: 105px !important;
        height: 58px !important;
        padding: unset !important;
        
        &:not(:first-child) {
            margin-left: 10px;
        }

        .mob-img {
            left: 0;
            transform: translate(0%, -50%);
            bottom: 50%;
            width: 32px;
            height: 32px;
        }
        .comp-box {
            margin: auto;
        }
        .text-title {
            margin-top: -10px !important;
            font-size: 14px;
        }
        .mob-text {
            display: none;
        }
    }
}
</style>
